export const Types = {
  SET_FILTERS: 'SET_FILTERS',
  GET_CAMPAIGNS: 'GET_CAMPAIGNS',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  GET_SUBMISSIONS: 'GET_SUBMISSIONS',
  APPROVE_SUBMISSION: 'APPROVE_SUBMISSION',
  UNAPPROVE_SUBMISSION: 'UNAPPROVE_SUBMISSION',
  DELETE_SUBMISSION: 'DELETE_SUBMISSION',
  FAVORITE_SUBMISSION: 'FAVORITE_SUBMISSION',
  UNFAVORITE_SUBMISSION: 'UNFAVORITE_SUBMISSION',
    AUDIT_RECEIPT: 'AUDIT_RECEIPT',
    APPROVE_RECEIPT: 'APPROVE_RECEIPT',
    REJECT_RECEIPT: "REJECT_RECEIPT",
    AUDIT_SUCCESSFUL: 'AUDIT_SUCCESSFUL',
    RESEND_EMAIL: "RESEND_EMAIL",
    EMAIL_SENT: "EMAIL_SENT",
    TOGGLE_SILENT_REJECTION: "TOGGLE_SILENT_REJECTION",
    FAILED_TO_AUDIT_SUBMISSION: "FAILED_TO_AUDIT_SUBMISSION",
    UPDATE_SEARCH_QUERY: "UPDATE_SEARCH_QUERY",
    SEND_SEARCH_QUERY: "SEND_SEARCH_QUERY",
    RECEIVED_SEARCH_QUERY: "RECEIVED_SEARCH_QUERY",
    TOGGLE_FILTER_ACCORDION: "TOGGLE_FILTER_ACCORDION",
};

export const setFiltersAction = (filters) => ({
  type: Types.SET_FILTERS,
  filters,
});

// could be initPageAction
export const getCampaignsAction = (masterCampaignId, ugcResourceType, additionalFilters) => ({
  type: Types.GET_CAMPAIGNS,
  masterCampaignId,
  ugcResourceType,
  additionalFilters
});

export const setCampaignsAction = (masterCampaignId, campaigns) => ({
  type: Types.SET_CAMPAIGNS,
  campaignId: masterCampaignId,
  campaigns,
});

export const getSubmissionsAction = (masterCampaignId, ugcResourceType, page, platforms, additionalFilters) => ({
  type: Types.GET_SUBMISSIONS,
  masterCampaignId,
  ugcResourceType,
  page,
  platforms,
  additionalFilters
});

export const approveSubmissionAction = id => ({
  type: Types.APPROVE_SUBMISSION,
  id
});

export const unapproveSubmissionAction = id => ({
  type: Types.UNAPPROVE_SUBMISSION,
  id
});

export const deleteSubmissionAction = id => ({
  type: Types.DELETE_SUBMISSION,
  id
});

export const favoriteSubmissionAction = id => ({
  type: Types.FAVORITE_SUBMISSION,
  id
});

export const unfavoriteSubmissionAction = id => ({
  type: Types.UNFAVORITE_SUBMISSION,
  id
});

export const auditReceiptAction = (id) => ({
    type: Types.AUDIT_RECEIPT,
    submissionId: id
});

export const approveReceiptAction = (id) => ({
    type: Types.APPROVE_RECEIPT,
    id
});

export const rejectReceiptAction = (id, reason, message, silent) => ({
  type: Types.REJECT_RECEIPT,
  id, 
  reason, 
  message,
  silent 
});

export const auditSuccessfulAction = (id, auditAction) => ({
    type: Types.AUDIT_SUCCESSFUL,
    id,
    auditAction
});

export const resendEmailAction = (id) => ({
    type: Types.RESEND_EMAIL,
    id
});

export const emailSentAction = (id) => ({
    type: Types.EMAIL_SENT,
    id
});


export const failedToAuditSubmissionAction = (id, reason) => ({
    type: Types.FAILED_TO_AUDIT_SUBMISSION,
    id,
    reason
});

export const updateSearchQueryAction = (query) => ({
    type: Types.UPDATE_SEARCH_QUERY,
    query
});

export const sendSearchQueryAction = (searchQuery, filters) => ({
    type: Types.SEND_SEARCH_QUERY,
    searchQuery,
    filters
});

export const receivedSearchQueryAction = (results) => ({
    type: Types.RECEIVED_SEARCH_QUERY,
    results
});

export const toggleFilterAccordionAction = () => ({
    type: Types.TOGGLE_FILTER_ACCORDION
});



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/actions.js